<template>
  <div class="formPreview">
    <div class="top-btn">
      <el-button class="print" type="primary" size="small" @click="doPrint">
        打印
      </el-button>
      <!-- <el-button class="close" type="danger">关闭</el-button> -->
    </div>
    <div class="formPreview-content" id="printHTML" ref="print">
      <div class="title" id="printTitle">
        <span class="formImg">
          <img src="favicon.ico" />
        </span>
        <span class="formTitle">{{ procInst.name }}</span>
        <div class="rightInfo"></div>
      </div>
      <div class="form" :key="tab.TabCode" v-for="tab in tabList">
        <div class="requireForm">
          <el-descriptions class="margin-top" :column="3" border>
            <template v-for="(item, index) in columnList[tab.TabCode]">
              <template v-if="item.CardShowFlag === true">
                <!-- 备注说明 -->
                <el-descriptions-item
                  label-class-name="my-label blank"
                  content-class-name="my-content entireRow left"
                  :key="index"
                  v-if="item.DataType === 200 || item.DataType === 110"
                  :span="3"
                >
                  <span
                    v-if="item.DataType === 110"
                    v-html="
                      item.DefaultShowValue
                        ? item.DefaultShowValue.replace(/\n/g, '</br>')
                        : ''
                    "
                  ></span>
                  <span
                    v-else
                    v-html="
                      item.DefaultShowName
                        ? item.DefaultShowName.replace(/\n/g, '</br>')
                        : ''
                    "
                  ></span>
                </el-descriptions-item>
                <!-- 子表 -->
                <template
                  v-else-if="item.DataType === 203"
                  v-for="(sData, sDataindex) in subTableData[item.ItemKey]"
                >
                  <el-descriptions-item
                    label-class-name="my-label blank"
                    content-class-name="my-content entireRow"
                    :key="sDataindex"
                    :span="3"
                  >
                    <span>{{ item.DefaultShowName + (sDataindex + 1) }}</span>
                  </el-descriptions-item>
                  <!-- <template v-for="sItem in columnList[item.ItemKey]"> -->
                  <el-descriptions-item
                    v-for="(sItem, sIndex) in columnList[item.ItemKey]"
                    :key="sIndex"
                    v-if="sItem.CardShowFlag === true"
                    label-class-name="my-label"
                    content-class-name="my-content"
                  >
                    <template slot="label">
                      {{ sItem.DefaultShowName }}
                    </template>
                    {{ sData[sItem.ItemKey] }}
                  </el-descriptions-item>
                  <!-- </template> -->
                </template>
                <!-- 图片 -->
                <el-descriptions-item
                  label-class-name="my-label"
                  content-class-name="my-content"
                  :key="index"
                  v-if="item.DataType === 10 || item.DataType === 11"
                  :span="3"
                >
                  <template slot="label">{{ item.DefaultShowName }}</template>
                  <template>
                    <div
                      class="table_cell_value"
                      style="text-align: left"
                      v-for="(fileVo, index) in uploadFileList[item.ItemKey]"
                      :key="index + 'five'"
                    >
                      <img
                        style="max-width: 400px; max-height: 400px"
                        :src="'/dfsFile/' + fileVo.fullPath"
                        alt
                      />
                    </div>
                  </template>
                </el-descriptions-item>
                <!-- 附件 -->
                <el-descriptions-item
                  label-class-name="my-label"
                  content-class-name="my-content"
                  :key="index"
                  v-else-if="
                    item.DataType === 104 ||
                    item.DataType === 102 ||
                    item.DataType === 105 ||
                    item.DataType === 106
                  "
                  :span="3"
                >
                  <template slot="label">{{ item.DefaultShowName }}</template>
                  <template>
                    <div
                      class="table_cell_value"
                      v-for="(fileVo, fileVoindex) in uploadFileList[item.ItemKey]"
                      :key="fileVoindex"
                    >
                      <span>{{ fileVo.fileName }}</span>
                    </div>
                  </template>
                </el-descriptions-item>
                <!-- 子表表格 -->
                <template v-else-if="item.DataType === 202">
                  <el-descriptions-item
                    label-class-name="my-label blank"
                    content-class-name="my-content entireRow"
                    :key="index"
                    :span="3"
                  >
                    <span>{{ item.DefaultShowName }}</span>
                  </el-descriptions-item>
                  <el-descriptions-item
                    label-class-name="my-label blank"
                    content-class-name="my-content entireRow"
                    :key="index"
                    :span="3"
                  >
                    <el-table
                      border
                      size="mini"
                      style="width: 100%"
                      :data="subTableData[item.ItemKey]"
                      :ref="'flowSubTable_' + item.ItemKey"
                      :header-cell-style="{
                        backgroundColor: '#f6f6f6',
                        color: '#666'
                      }"
                    >
                      <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="50"
                      />
                      <template v-for="(sItem, index) in columnList[item.ItemKey]">
                        <el-table-column
                          v-if="sItem.CardShowFlag"
                          :key="index"
                          :prop="sItem.ItemKey"
                          :label="sItem.DefaultShowName"
                        >
                          <template slot-scope="scope">
                            <template v-if="sItem.DataType === 22">
                              <img
                                style="width: 100px"
                                :src="'/dfsFile/' + scope.row[sItem.ItemKey]"
                              />
                              <!-- <el-image
                                class="signImage"
                                :src="'/dfsFile/' + scope.row[sItem.ItemKey]"
                                :preview-src-list="['/dfsFile/' + scope.row[sItem.ItemKey]]"
                              />-->
                            </template>
                            <template v-else>
                              {{ scope.row[sItem.ItemKey] }}
                            </template>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table>
                  </el-descriptions-item>
                </template>
                <!-- 其他 -->
                <template v-if="getData(columnList[tab.TabCode], index, item)">
                  <el-descriptions-item
                    label-class-name="my-label"
                    content-class-name="my-content"
                    :span="
                      getData(columnList[tab.TabCode], index) ? 3 : item.Width
                    "
                    :key="index"
                  >
                    <template slot="label">{{ item.DefaultShowName }}</template>
                    <div v-if="item.DataType !== 25">
                      <img
                        v-if="item.DataType === 22"
                        style="width: 100px"
                        :src="'/dfsFile/' + formData[item.ItemKey]"
                      />
                      <span
                        v-else-if="item.DataType === 20 || item.DataType === 21"
                      >
                        {{ formData[item.ItemKey.replace('code', 'name')] }}
                      </span>
                      <span v-else>{{ formData[item.ItemKey] }}</span>
                    </div>
                    <template v-if="item.DataType === 25">
                      <div
                        v-for="flowInfo in JSON.parse(formData[item.ItemKey])"
                        :key="flowInfo.id"
                      >
                        {{ flowInfo.name }}
                      </div>
                    </template>
                  </el-descriptions-item>
                </template>
              </template>
            </template>
            <template v-for="(userTask, index) in procInst.userTaskList">
              <el-descriptions-item
                label-class-name="my-label"
                content-class-name="my-content"
                span="3"
                :key="index"
                v-if="(userTask.approvalTime || (!userTask.approvalTime && userTask.commentList && userTask.commentList.length)) && !userTask.cxpx"
              >
                <template slot="label">{{ userTask.name }}</template>
                <div class="comment">
                  {{ userTask.comment }}
                </div>
                <div class="content">
                  <div class="comment-list">
                    <span v-if="userTask.approvalStatus != 'REVOKE'">
                      {{ userTask.assigneeName }}
                      <span v-if="userTask.approvalStatus == 'COMMIT'">
                        提交于
                      </span>
                      <span v-if="userTask.approvalStatus == 'APPROVAL'">
                        已同意
                      </span>
                      <span v-if="userTask.approvalStatus == 'REJECT'">
                        已拒绝
                      </span>
                      <span v-if="userTask.approvalStatus == 'RECALL'">
                        已撤回
                      </span>
                      <span v-if="userTask.approvalStatus == 'ADDSIGNBEFORE'">
                        前加签
                      </span>
                      <span v-if="userTask.approvalStatus == 'ADDSIGNAFTER'">
                        后加签
                      </span>
                      <span
                        v-if="
                          userTask.approvalStatus == 'TRANS' ||
                          userTask.approvalStatus == '转办'
                        "
                      >
                        转交于
                      </span>
                    </span>
                    <span v-if="userTask.approvalStatus == 'REVOKE'">
                      {{
                        '发起人 ' +
                        procInst.userTaskList[0].assigneeName +
                        ' 已撤销申请于'
                      }}
                    </span>
                    <span>{{ userTask.approvalTime }}</span>
                  </div>
                </div>
                <template v-if="userTask.commentList">
                  <div
                    class="content"
                    v-for="comment in userTask.commentList"
                    :key="comment.id"
                  >
                    <div class="comment-list">
                      <span class="commentInfo">
                        {{ comment.userName + ' 添加了评论：' }}
                      </span>

                      <div class="comment">
                        <p v-if="comment.message.includes('comment_color')" v-html="comment.message.replace(/\n/g, '</br>')"></p>

                        <div v-else v-for="(item, index) in comment.message.split('###')" :key="index" style="text-align: left;">
                          <span v-for="(s, i) in item.split('%%%')" :key="i" :class="{'commentPadding': s[0] === '@'}">{{ s }}</span>
                        </div>
                        <span class="commentInfo">{{ comment.time }}</span>
                      </div>
                    </div>
                    <div class="content" v-if="'file' in comment">
                      <span
                        v-for="file in commentFiles(comment.file)"
                        :key="file"
                      >
                        <img
                          v-if="
                            file &&
                            file.identification &&
                            file.identification.split('/')[2] === 'commentImg' &&
                            !file.intranet
                          "
                          :src="'/dfsFile/' + file.fullPath"
                          style="max-width: 200px"
                        />
                        <span
                          v-else-if="
                            file &&
                            file.identification &&
                            file.identification.split('/')[2] !== 'commentImg' &&
                            !file.intranet
                          "
                        >
                          <i class="el-icon-document"></i>
                          {{ file.fileName }}
                        </span>
                      </span>
                    </div>
                  </div>
                </template>
              </el-descriptions-item>
            </template>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { removeWatermark, setWaterMark } from '@/util/water.js'
import { formatDate } from '@/util/formatUtil'
export default {
  props: {
    fromWhere: {
      type: String,
      default: ''
    },
    procInst: {
      type: Object,
      default: () => {}
    },
    tabList: {
      type: Array,
      default: () => []
    },
    columnList: {
      type: Array,
      default: () => []
    },
    editFormData: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    subTableData: {
      type: Object,
      default: () => {}
    },
    uploadFileList: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  },
  computed: {},
  mounted () {
    try {
      document.getElementsByClassName('entireRow').forEach(res => {
        res.colSpan = '6'
      })
    } catch (e) {
      console.log('🎈-----formPreview.vue-376-----', e)
    }

    if (!this.procInst.procExtends.watermarkSwitch) return
    const vuex = JSON.parse(sessionStorage.getItem('vuex') || '{}')
    setWaterMark(vuex.user.psnName + '-' + vuex.user.psnCode + ' ' + formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'))
  },
  destroyed () {
    removeWatermark()
  },
  methods: {
    getData (data, index, item) {
      var arrDataType = [10, 11, 200, 202, 203, 102, 104, 105, 106, 110]
      var isTrue = true
      var isDataType = ''
      if (item) {
        isDataType = arrDataType.indexOf(item.DataType) === -1
        isTrue = isDataType
      } else {
        if (data.length - 1 === index) {
          return isTrue
        }
        isDataType = arrDataType.indexOf(data[index + 1].DataType) !== -1
        isTrue =
          data[index + 1].Width === 4 ||
          data[index + 1].Width === 3 ||
          isDataType
      }
      return isTrue
    },
    doPrint () {
      let _this = this
      _this.$print(_this.$refs.print)
      // var printHTML = document.getElementById('printHTML').innerHTML
      // var oldHTML = document.body.innerHTML
      // document.body.innerHTML = printHTML
      // window.print()
      // location.reload()
      // document.body.innerHTML = oldHTML
    },
    commentFiles (data) {
      return JSON.parse(data)
    }
  }
}
</script>
<style>
@media print {
  body {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
<style lang="scss" scoped>
.top-btn {
  text-align: right;
}

.formPreview-content {
  padding-top: 10px;
  padding-right: 50px;
  padding-left: 50px;
}

.title {
  display: flex;
}

.formImg,
.rightInfo {
  height: 64px;
  flex: 2;
}

.formImg img {
  margin-left: 5px;
}

.form {
  font-size: 16px;
}

.formTip {
  font-weight: bold;
}

.defaultShowName,
.formContent {
  display: flex;
  align-items: center;
  border: 1px solid;
  margin-right: -1px;
  margin-top: -1px;
}

.longWidth {
  border-right: none;
  padding: 3px;
}

.shortWidth {
  height: 48px;
  width: 16.76%;
  text-align: center;
}

.halfPrintWidth {
  width: 50.1%;
}

.allPrintWidth {
  width: 83.4%;
}

.defaultShowName div,
.formContent div,
.opinionShowName div,
.opinionContent div {
  width: 100%;
}

.opinionShowName,
.opinionContent {
  display: flex;
  height: 100px;
  align-items: center;
  text-align: center;
  border-right: 1px solid;
  border-bottom: 1px solid;
}

.formTitle {
  display: flex;
  flex: 4;
  font-size: 28px;
  align-items: center;
  justify-content: space-around;
}

.rightInfo {
  display: flex;
  flex-direction: column;
  height: 44px;
  padding-top: 10px;
}

.rightInfo div {
  display: inline-block;
  font-size: 14px;
  margin-left: 40px;
  height: 22px;
}
.requireForm >>> .el-descriptions-item__label.is-bordered-label {
  width: 150px !important;
}
.requireForm >>> .my-label {
  color: #525252;
  text-align: center;
  background: #fff;
  border: 1px solid #525252;
}
.requireForm >>> .blank {
  display: none;
}
.requireForm >>> .left {
  text-align: left !important;
}
.requireForm >>> .my-content {
  text-align: center;
  border: 1px solid #525252;
}

.comment {
  text-align: left;
}

.content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.comment-list {
  width: 100%;
  display: flex;

  .commentInfo {
    flex-shrink: 0;
  }

  .comment {
    flex: 1 1 auto;
  }
}

.commentPadding {
  padding-right: 10px;
}

/* .commentInfo {
  min-width: 130px;
} */
</style>
